<template>
    <div :class="['container', { 'container-dark': theme_dark }]">
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable"></span>
        </div>
        <div class="nav-middle">反馈详情</div>
        <div class="nav-right">
          <span class="nav-lable" @click="goto_faceback_history()"></span>
          <img src="../../assets/img/发布.png" class="nav-img none" />
        </div>
      </div>

      <div class="content">
        <div class="conent-item">
          <div class="ub ub-ver">
            <div class="ub ub-pc ub-ps">
              <span class="font-color">问题描述</span>
            </div>
            <textarea contenteditable="true" v-model="txt" class="describe-text" readonly="readonly"></textarea>

          </div>

          <div class="ub ub-ver screenshots-block">
            <div class="ub ub-pc ub-ps">
              <span class="font-color">问题截图</span>
            </div>
            <div class="ub ub-ac1">
              <li class="screenshots-div ub ub-ac ub-pc ub-ver" v-for="(i,index) in ayy_pic" :key="index" >
                <img :src="i" @click="show_full(i)"/>
              </li>
            </div>
          </div>

          <div class="menu-line"></div>

          <div class="screenshots-block ub" >
            <div class="ub ub-pc ub-ps">
              <span class="font-color">审核状态:</span>
              <span class="sp3 green" v-if="state=='成功'">{{state}}</span>
                <span class="sp3 red" v-if="state=='失败'">{{state}}</span>
                <span class="sp3 gray" v-if="state=='待审核'">{{state}}</span>
            </div>
          </div>

          <div class="menu-line"></div>

          <div class="screenshots-block ub ub-ver">
            <div class="ub ub-pc ub-ps">
              <span class="font-color">审核结果</span>
            </div>
            <textarea contenteditable="true" v-model="rst" class="describe-text" readonly="readonly"></textarea>
          </div>
        </div>
      </div>


      <alert ref="myConfirm"></alert>

      <full_pic ref="myFullPic"></full_pic>
    </div>
  </template>

  <script>
  import Exif from "exif-js";
  import * as tool from "../../api/common";
  import Alert from "../../components/Alert.vue";
  import full_pic from "../../components/Full_Pic.vue";
  import { mapMutations, mapActions } from "vuex";
  export default {
    components: {
      alert: Alert,
      full_pic: full_pic,
    },
    data() {
      return {
        id:"",
        txt: "",
        ayy_pic: [],
        state:"",
        rst:"",
        theme_dark: false
      };
    },
   mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
      var id = this.$route.params.id;
      this.id = id;
      this.init();
    },
    methods: {
      ...mapMutations(["get", "post", "post2"]), //引入方法
      back() {
        this.$router.go(-1); //返回上一层
      },
       show_full(url) {
        this.$refs.myFullPic.show(url);
      },

      init() {
        var self = this;
        self.get({
          url: "/App/GetUserTsOneData/?id=" + self.id,
          success: function(data_serve) {

            console.log(JSON.stringify(data_serve));
            self.txt= data_serve.brife;
            self.state=data_serve.check_state;
            self.rst=data_serve.rst_check;
             //去掉空格
              data_serve.pics = data_serve.pics.replace(/\ +/g, "");
              //去掉回车换行
              data_serve.pics = data_serve.pics.replace(/[\r\n]/g, "");
              self.ayy_pic= JSON.parse(data_serve.pics);
              console.log(self.state);
          },
          error: function(err) {
          }
        });
      },

    },
  };
  </script>

  <style lang="scss" scoped>
  .container {
    height: 100vh;
    background-color: #EFEFEF;
  }
  .content {
    padding: 0 0.8rem;
    margin-top: 1rem;
    .conent-item {
      padding: 1rem 0.8rem;
      border-radius: 0.5rem;
      background-color: #FDFDFD;
      .font-color {
        font-size: 0.9rem;
        color: #333;
      }
      .describe-text {
        margin-top: 1rem;
        outline: none;
        border-color: #333;
        background-color: transparent;
        border-radius: 0.5rem;
        padding: 0.8rem;
        color: #333;
        font-size: 0.9rem;
        resize: none;
        -webkit-appearance: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }
    }
  }

  .screenshots-block {
    background-color: transparent;
    margin-top: 1rem;
    .screenshots-div {
      margin-top: 1rem;
      border: 1px solid rgba(255,255,255,0.2);
      img {
        max-width: 4rem;
        max-height: 4rem;
      }
    }

    .gray{
        color: #333;
    }
    .green{
        color: #04f82d;
    }
    .red{
        color:#ff0000;
    }
    .sp3 {
      margin-left: 1rem;
      font-size: 0.75rem;
    }
  }

  .menu-line {
    margin-top: 1rem;
  }

  .container-dark {
    background-color: #2f2e33;
    .content {
      .conent-item {
        background-color: #2c2b30;
      }
      .font-color {
        color: #888;
      }
      .describe-text {
        border-color: #404040;
        color: #888;
      }
    }
    .screenshots-block {
      .gray{
        color: #666;
    }
    }
  }
  </style>
